import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { ref } from "vue";
import { getClasses } from "~/js/composables/classes";

interface Props {
	color?: string;
	alignment?: string;
	utilities?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'TextH4',
  props: {
    color: { default: "text-black" },
    alignment: { default: "text-left" },
    utilities: { default: "" }
  },
  setup(__props: any) {

const props = __props;

const classes = ref({
	alignment: props.alignment,
	color: props.color,
	font: "font-primary font-bold text-h4-sm md:text-h4-md lg:text-h4-lg",
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: _normalizeClass([props.utilities, _unref(getClasses)(classes.value)])
  }, [
    _renderSlot(_ctx.$slots, "default")
  ], 2))
}
}

})